import React, {useState} from 'react'
import './qualification.css'
import qualificationData from './qualificationData.json'

const Qualification = () => {
    const [toggleState, setToggleState] = useState(1);
    const toggleTab = (index) => {
        setToggleState(index);
    }

    const renderTimelineItem = (item, isLeftAligned, isLastItem = false, key) => (
        <div className="qualification__data" key={key}>
            {isLeftAligned ? (
                <div>
                    <h3 className="qualification__title">{item.title}</h3>
                    <span className="qualification__subtitle">{item.subtitle}</span>
                    {item.details?.length > 0 && (
                        <div className="qualification__details">
                            {item.details.map((detail, index) => (
                                <p key={index} className="qualification__detail">{detail}</p>
                            ))}
                        </div>
                    )}
                    <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i>{item.date}
                    </div>
                </div>
            ) : (
                <div></div>
            )}

            <div>
                <span className="qualification__rounder"></span>
                {!isLastItem && <span className="qualification__line"></span>}
            </div>

            {!isLeftAligned ? (
                <div>
                    <h3 className="qualification__title">{item.title}</h3>
                    <span className="qualification__subtitle">{item.subtitle}</span>
                    {item.details?.length > 0 && (
                        <div className="qualification__details">
                            {item.details.map((detail, index) => (
                                <p key={index} className="qualification__detail">{detail}</p>
                            ))}
                        </div>
                    )}
                    <div className="qualification__calendar">
                        <i className="uil uil-calendar-alt"></i>{item.date}
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )

  return (
    <section className="qualification section" id="qualifications">
        <h2 className="section__title">Qualifications</h2>
        <span className="section__subtitle"></span>

        <div className="qualification__container container">
            <div className="qualification__tabs">
                <div className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"} onClick={() => toggleTab(1)}>
                    <i className="uil uil-graduation-cap qualification__icon"></i>
                    Experience
                </div>

                <div className={toggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button button--flex"} onClick={() => toggleTab(2)}>
                    <i className="uil uil-briefcase-alt qualification__icon"></i>
                    Extracurriculars
                </div>
            </div>

            <div className="qualification__section">
                <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    {qualificationData.experience.map((item, index) => renderTimelineItem(item, index % 2 === 0, index === qualificationData.experience.length - 1, `experience-${index}`))}

                </div>


                <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                    {qualificationData.extracurriculars.map((item, index) => renderTimelineItem(item, index % 2 === 0, index === qualificationData.extracurriculars.length - 1, `extracurricular-${index}`))}

                    
                </div>
            </div>
        </div>
    </section>
  )
}

export default Qualification
